export default __webpack_public_path__ + "static/media/location.0d7827cd.svg";